module.exports = __webpack_public_path__ + "static/media/module-administratie.cb551512.webp";